import {
  ARCHIVE_EXTENSIONS,
  ARCHIVE_MIME_TYPES,
  DEFAULT_FILE_TYPE,
  MIME_TYPE_LABEL_MAP,
  VIDEO_EXTENSIONS,
  VIDEO_MIME_TYPES,
} from './constants'
import type { MessageFileIconPath } from './types'

const sanitizeLabel = (value?: string) => {
  if (!value) {
    return undefined
  }

  const sanitized = value.replace(/[^a-z0-9]/gi, '')
  if (!sanitized) {
    return undefined
  }

  return sanitized.toUpperCase()
}

const getLabelFromMime = (mimeType?: string) => {
  const normalizedMime = mimeType?.trim().toLowerCase()
  if (!normalizedMime) {
    return undefined
  }

  const mappedLabel = MIME_TYPE_LABEL_MAP.get(normalizedMime)
  if (mappedLabel) {
    return mappedLabel
  }

  return undefined
}

export const getFileTypeLabel = (
  mimeType?: string,
  fallbackExtension?: string
) => {
  const labelFromMime = getLabelFromMime(mimeType)
  if (labelFromMime) {
    return labelFromMime
  }

  const sanitizedExtension = sanitizeLabel(fallbackExtension)
  if (sanitizedExtension) {
    return sanitizedExtension
  }

  return DEFAULT_FILE_TYPE
}

export const getFileIconPath = (
  mimeType?: string,
  fileType?: string
): MessageFileIconPath => {
  const normalizedMime = mimeType?.trim().toLowerCase()
  if (normalizedMime) {
    if (
      VIDEO_MIME_TYPES.has(normalizedMime) ||
      normalizedMime.startsWith('video/')
    ) {
      return 'icons/icon-file-video'
    }

    if (ARCHIVE_MIME_TYPES.has(normalizedMime)) {
      return 'icons/icon-file-archive'
    }
  }

  const normalizedType = fileType?.trim().toUpperCase()
  if (normalizedType) {
    if (VIDEO_EXTENSIONS.has(normalizedType)) {
      return 'icons/icon-file-video'
    }

    if (ARCHIVE_EXTENSIONS.has(normalizedType)) {
      return 'icons/icon-file-archive'
    }
  }

  return 'icons/icon-file'
}
